import type { TranslationModule } from '../types';

export const homeTranslations: TranslationModule = {
  ro: {
    skipToContent: "Sari la conținut",
    searchAria: "LegeaAplicată — Căutare juridică",
    forProfessionals: "Pentru profesioniști",
    forYou: "Pentru tine",
    eyebrow: "LEGEA APLICATĂ · CLARITATE JURIDICĂ ȘI RESURSE DE STUDIU",
    quickStartHint: "Caută o speță, un articol sau un concept…",
    quickStartCta: "Testează gratuit",
    quickStartAriaLabel: "Caută o speță, un articol sau un concept… — Testează gratuit",
    heroTitlePart1: "Cercetare juridică online.",
    heroTitlePart2: "Informații, spețe și resurse pentru studiu.",
    heroIntro: "LegeaAplicată reunește instrumente pentru cercetare juridică, căutarea cazurilor asemănătoare și pregătirea examenelor juridice.",
    howToStart: "Cum vrei să începi?",
    choice1Badge: "PENTRU PROFESIONIȘTI",
    choice1Title: "Cercetare și documentare juridică",
    choice1Desc: "Cercetează legislația, hotărârile judecătorești și motivările instanțelor. Instrumente de analiză și verificare a surselor.",
    choice1Link: "Începe cercetarea juridică",
    choice2Badge: "PENTRU SITUAȚIA TA",
    choice2Title: "Cazuri asemănătoare în cuvintele tale",
    choice2Desc: "Descrie problema în propriile cuvinte și află ce au decis instanțele în situații comparabile, fără formulări complicate.",
    choice2Link: "Găsește cazuri asemănătoare",
    studyBadge: "PENTRU STUDIU",
    studyTitle: "Ești student la Drept sau te pregătești pentru un examen juridic?",
    audioLegislation: "Audio Legislație",
    elementsToMemorize: "Elemente de memorat",
    examPrep: "Pregătire examene",
    audioQuizzes: "Audio Grile",
    legalCalculators: "Calculatoare juridice",
    previewAria: "Exemplu ilustrativ de cercetare profesională",
    previewBadge: "EXEMPLU DE CERCETARE",
    previewLabel: "DE LA ÎNTREBARE LA SURSE REALE",
    previewQueryPart1: "O întrebare clară.",
    previewQueryPart2: "Surse juridice verificate.",
    previewLegislationTitle: "Legislație",
    previewLegislationDesc: "Cadrul normativ în vigoare",
    previewJurisprudenceTitle: "Jurisprudență",
    previewJurisprudenceDesc: "Hotărâri și argumente de comparat",
    previewBottom: "Citește sursa integrală. Verifică aplicabilitatea.",
    previewCaption: "FLUX ILUSTRATIV · TU PĂSTREZI CONTROLUL ANALIZEI",
    studySectionBadge: "FACULTATE DE DREPT ȘI ADMITERE ÎN PROFESIILE JURIDICE",
    studySectionTitlePart1: "Învață, recapitulează,",
    studySectionTitlePart2: "fixează noțiunile importante.",
    studySectionDesc: "Pregătește-te pentru examenele juridice cu legislație în format audio și instrumente de memorare. Ascultă, urmărește textul și revino asupra clasificărilor, condițiilor și excepțiilor importante.",
    studyAudioBadge: "TEXT ȘI AUDIO SINCRONIZAT",
    studyAudioTitle: "Audio Legislație: text și audio pentru studiu",
    studyAudioDesc: "Ascultă coduri, legi și acte normative și urmărește textul pentru a reveni la pasajele pe care vrei să le aprofundezi. Folosește timpul de acasă sau din deplasări pentru recapitularea legislației.",
    studyAudioLink: "Ascultă legislația",
    audioStudyImageAria: "Deschide modulul Audio Legislație",
    studyMemoryBadge: "RECAPITULARE STRUCTURATĂ",
    studyMemoryTitle: "Elemente de memorat pentru examenele juridice",
    studyMemoryDesc: "Fixează clasificări, condiții, excepții și reguli juridice prin recapitulare structurată. Revino asupra noțiunilor importante și verifică ceea ce ai reținut, în funcție de materialele disponibile.",
    studySubjectCivil: "Drept civil",
    studySubjectCivilDesc: "Clasificări, obligații, contracte și succesiuni",
    studySubjectCivilProc: "Drept procesual civil",
    studySubjectCivilProcDesc: "Competență, acte de procedură, termene și căi de atac",
    studySubjectPenal: "Drept penal",
    studySubjectPenalDesc: "Partea generală, cauze justificative, pedepse și infracțiuni",
    studySubjectPenalProc: "Drept procesual penal",
    studySubjectPenalProcDesc: "Urmărire penală, măsuri preventive și judecată",
    studyMemoryNote: "Resursele sunt utile pentru facultatea de drept și pregătirea examenelor precum INM, Barou și SNG, în raport cu programa și materialele publicate.",
    studyMemoryLink: "Explorează elementele de memorat",
    studyExamsLink: "Pregătire pentru examene juridice",
    publicSectionBadge: "NU TREBUIE SĂ CUNOȘTI LEGEA CA SĂ ÎNCEPI",
    publicSectionTitlePart1: "De la situația ta",
    publicSectionTitlePart2: "la cazuri comparabile.",
    publicSectionDesc: "Poate ai împrumutat bani și nu i-ai mai primit înapoi. Poate ai o problemă cu vecinii, cu locul de muncă, cu o locuință sau cu un contract. Nu trebuie să știi articole de lege și nici să folosești cuvinte juridice.",
    example1: "Bani împrumutați și nerestituiți",
    example2: "Vecinul a ocupat o parte din teren",
    example3: "Salariu neplătit",
    demoFlowAria: "Etapele căutării cazurilor comparabile",
    step1Title: "Descrii ce s-a întâmplat",
    step1Desc: "Scrii problema în cuvintele tale obișnuite, așa cum ai explica-o unei persoane apropiate, fără termeni tehnici.",
    step1SampleTag: "Exemplu introdus:",
    step1SampleText: "„Am împrumutat bani unui coleg și refuză să îi restituie, deși avem confirmări scrise.”",
    step2Title: "Identificarea cazurilor similare",
    step2Desc: "Platforma caută procese cu împrejurări comparabile în materialele disponibile.",
    step2Tag: "Căutare după împrejurări:",
    step2Bullet1: "Împrumuturi între persoane fizice",
    step2Bullet2: "Dovezi analizate: transferuri, mesaje",
    step3Title: "Vezi ce au decis judecătorii",
    step3Desc: "Consulți ce elemente au contat în analiză, cum au fost cântărite dovezile și soluția pronunțată.",
    step3Tag: "Informații disponibile:",
    step3Bullet1: "Împrejurări și dovezi admise",
    step3Bullet2: "Soluția și argumentele instanței",
    publicSearchBtn: "Caută situații asemănătoare",
    publicNote: "Prezentare ilustrativă. Fiecare situație are particularitățile ei. Un caz asemănător nu garantează aceeași soluție și nu înlocuiește analiza unui avocat.",
    platformSectionBadge: "PENTRU CEI CARE LUCREAZĂ CU LEGEA",
    platformSectionTitlePart1: "Legislație și jurisprudență",
    platformSectionTitlePart2: "pentru cercetarea ta.",
    platformSectionDesc: "Explorează legislația, jurisprudența și documentele relevante într-un spațiu de documentare construit pentru acuratețe. Identifică sursele primare, compară argumentele din motivări și fundamentează fiecare concluzie.",
    cardResearchBadge: "CERCETARE",
    cardResearchTitle: "Legislație și jurisprudență",
    cardResearchDesc: "Pornește de la cuvinte-cheie sau concepte juridice. Explorează <a href=\"/legislatie\">legislația</a> actualizată și hotărâri judecătorești, inclusiv <a href=\"/iccj\">jurisprudența ÎCCJ</a> și <a href=\"/cedo\">jurisprudența CEDO</a>.",
    cardAnalysisBadge: "ANALIZĂ JURIDICĂ",
    cardAnalysisTitle: "Documente în context",
    cardAnalysisDesc: "În căutare, folosește Atașează pentru a porni de la textul extras al unui dosar. Pentru documente Word, consultă <a href=\"/analiza-document\">analiza documentelor și a referințelor legislative</a>.",
    cardDocBadge: "DOCUMENTARE",
    cardDocTitle: "Surse și instrumente",
    cardDocDesc: "Completează documentarea cu <a href=\"/instrumente-gratuite\">instrumentele pentru termene și taxe judiciare</a>. Sistemul sprijină organizarea materialelor; evaluarea și formularea concluziilor îți aparțin.",
    platformBtn: "Deschide cercetarea juridică",
    platformNote: "Rezultatele asistate pot conține omisiuni. Verifică întotdeauna sursele oficiale și forma aplicabilă a normei înainte de utilizare.",
    filmBadge: "CUNOAȘTE LEGEA APLICATĂ",
    filmTitlePart1: "Descoperă tehnologia",
    filmTitlePart2: "din spatele Legea Aplicată.",
    filmDesc: "O prezentare a proiectului, a oamenilor și a ideilor care fac informația juridică mai accesibilă și mai verificabilă.",
    filmPlayBtn: "Vezi prezentarea",
    filmCaptionLabel: "ÎN SPATELE PLATFORMEI",
    filmCaptionTitle: "Prezentare Legea Aplicată",
    videoAria: "Prezentarea video Legea Aplicată",
    methodBadge: "SURSE, METODĂ ȘI ÎNCREDERE",
    methodTitlePart1: "Informații pe care",
    methodTitlePart2: "le poți verifica.",
    methodDesc1: "Materialele juridice trebuie consultate în contextul lor complet. O asemănare între două cazuri nu garantează aceeași soluție, iar normele trebuie verificate în forma lor în vigoare.",
    methodDesc2: "Consultă <a href=\"/surse-date\">sursele informațiilor juridice</a> și detaliile despre <a href=\"/securitate\">securitatea și protecția datelor</a>.",
    methodStep1Title: "Pornește de la întrebarea ta",
    methodStep1Desc: "Descrie problema în cuvintele tale sau formulează întrebarea juridică pe care o cercetezi.",
    methodStep2Title: "Compară în context",
    methodStep2Desc: "Citește textele de lege și motivările integrale. Verifică asemănările și deosebirile dintre situații.",
    methodStep3Title: "Verifică înainte să folosești",
    methodStep3Desc: "Consultă data, sursa și forma aplicabilă a legii. Pentru o opinie adaptată situației tale, discută cu un avocat.",
    faqBadge: "ÎNAINTE SĂ ÎNCEPI",
    faqTitlePart1: "Întrebări frecvente.",
    faqTitlePart2: "Răspunsuri clare.",
    faq1Q: "Cum aleg de unde să încep?",
    faq1A: "Dacă lucrezi în domeniul juridic, începe cu <a href=\"/cautare\">cercetarea juridică</a>. Dacă vrei să înțelegi o problemă proprie, <a href=\"/cazuri-asemanatoare\">găsește cazuri asemănătoare</a> descriind ce s-a întâmplat. Iar dacă ești student sau candidat la examene, începe cu <a href=\"/audio-legislatie\">Audio Legislație</a> și <a href=\"/elemente-de-memorat\">Elementele de memorat</a>.",
    faq2Q: "Trebuie să cunosc termeni de drept?",
    faq2A: "Nu. Pentru cazuri asemănătoare, poți scrie în cuvintele tale obișnuite. Explică ce s-a întâmplat, când și ce dorești să lămurești; nu ai nevoie de articole de lege ca să începi.",
    faq3Q: "Un caz asemănător garantează același rezultat?",
    faq3A: "Nu. Împrejurările, probele și regulile aplicabile diferă de la o cauză la alta. Compară și diferențele, verifică sursele și discută situația ta cu un avocat. Platforma sprijină informarea și nu înlocuiește consultanța unui profesionist.",
    faq4Q: "Cum mă ajută Audio Legislație în pregătirea examenelor?",
    faq4A: "Modulul <a href=\"/audio-legislatie\">Audio Legislație</a> oferă coduri și legi sincronizate text-audio. Poți asculta articolele în deplasare sau acasă, urmărind textul pentru fixarea formulărilor exacte din coduri.",
    faq5Q: "Ce acoperă secțiunea Elemente de memorat?",
    faq5A: "La <a href=\"/elemente-de-memorat\">Elemente de memorat</a> găsești clasificări, condiții, excepții și reguli structurate pentru materiile esențiale: civil, procedură civilă, penal și procedură penală, utile pentru examenele de facultate, INM, Barou și SNG.",
    faq6Q: "Pot porni cercetarea de la un document?",
    faq6A: "Da. În căutare, opțiunea Atașează permite extragerea textului dintr-un document sau dintr-o imagine pentru a căuta direct pe baza pasajelor relevante.",
    faq7Q: "Cum sunt tratate datele mele?",
    faq7A: "Consultă <a href=\"/privacy-policy\">politica de confidențialitate</a> înainte de a folosi date sau documente în platformă. Respectăm cerințele stricte de confidențialitate și securitate.",
    finalCtaBadge: "ALEGE PUNCTUL TĂU DE PLECARE",
    helpToday: "Cu ce te putem ajuta",
    today: "astăzi?",
    dockLegalResearch: "Cercetare juridică",
    dockSimilarCases: "Cazuri asemănătoare",
    guide: "Ghidul funcțiilor",
    guideLink: "Ghidul tuturor funcțiilor",
    dockGuide: "Ghid funcții",
    footerOperator: "Platformă operată de VERDICT LINE S.R.L. · <a href=\"/despre-noi\">Echipa și operatorul</a> · <a href=\"/ghid\">Ghidul funcțiilor & Matrice</a> · <a href=\"/contact\">Contact</a>"
  },
  en: {
    skipToContent: "Skip to content",
    searchAria: "LegeaAplicată — Legal search",
    forProfessionals: "For professionals",
    forYou: "For your situation",
    eyebrow: "LEGEA APLICATĂ · LEGAL CLARITY & STUDY RESOURCES",
    quickStartHint: "Explore cases, legal provisions or concepts…",
    quickStartCta: "Try for free",
    quickStartAriaLabel: "Explore cases, legal provisions or concepts… — Try for free",
    heroTitlePart1: "Online legal research.",
    heroTitlePart2: "Information, cases and study resources.",
    heroIntro: "LegeaAplicată brings together tools for legal research, finding similar cases, and legal exam preparation.",
    howToStart: "How would you like to start?",
    choice1Badge: "FOR PROFESSIONALS",
    choice1Title: "Legal research and documentation",
    choice1Desc: "Research legislation, court decisions and judicial reasoning. Analysis tools and source verification.",
    choice1Link: "Start legal research",
    choice2Badge: "FOR YOUR SITUATION",
    choice2Title: "Similar cases in your own words",
    choice2Desc: "Describe your problem in your own words and see what courts decided in comparable situations, without complex legal jargon.",
    choice2Link: "Find similar cases",
    studyBadge: "FOR STUDY",
    studyTitle: "Law student or preparing for a bar/judicial exam?",
    audioLegislation: "Audio Legislation",
    elementsToMemorize: "Key Elements to Memorize",
    examPrep: "Exam Preparation",
    audioQuizzes: "Audio Quizzes",
    legalCalculators: "Legal Calculators",
    previewAria: "Illustrative example of professional research",
    previewBadge: "RESEARCH EXAMPLE",
    previewLabel: "FROM QUESTION TO REAL SOURCES",
    previewQueryPart1: "A clear question.",
    previewQueryPart2: "Verified legal sources.",
    previewLegislationTitle: "Legislation",
    previewLegislationDesc: "Current regulatory framework",
    previewJurisprudenceTitle: "Jurisprudence",
    previewJurisprudenceDesc: "Decisions and arguments to compare",
    previewBottom: "Read the full source. Verify applicability.",
    previewCaption: "ILLUSTRATIVE WORKFLOW · YOU KEEP CONTROL OF THE ANALYSIS",
    studySectionBadge: "LAW SCHOOL AND ADMISSION TO LEGAL PROFESSIONS",
    studySectionTitlePart1: "Learn, review,",
    studySectionTitlePart2: "master the essential concepts.",
    studySectionDesc: "Prepare for legal exams with audio legislation and memorization tools. Listen, follow along with the text, and review key classifications, conditions, and exceptions.",
    studyAudioBadge: "SYNCHRONIZED TEXT AND AUDIO",
    studyAudioTitle: "Audio Legislation: text and audio for study",
    studyAudioDesc: "Listen to statutory codes, laws, and normative acts while following along with the text to revisit passages you wish to master. Use your commute or home study time to review legislation.",
    studyAudioLink: "Listen to legislation",
    audioStudyImageAria: "Open Audio Legislation module",
    studyMemoryBadge: "STRUCTURED REVIEW",
    studyMemoryTitle: "Key elements to memorize for legal exams",
    studyMemoryDesc: "Reinforce classifications, requirements, exceptions, and legal rules through structured review. Revisit essential concepts and test your retention based on available study materials.",
    studySubjectCivil: "Civil Law",
    studySubjectCivilDesc: "Classifications, obligations, contracts, and successions",
    studySubjectCivilProc: "Civil Procedural Law",
    studySubjectCivilProcDesc: "Jurisdiction, procedural acts, deadlines, and remedies",
    studySubjectPenal: "Criminal Law",
    studySubjectPenalDesc: "General part, justification defenses, penalties, and offenses",
    studySubjectPenalProc: "Criminal Procedural Law",
    studySubjectPenalProcDesc: "Criminal prosecution, preventive measures, and trial proceedings",
    studyMemoryNote: "Resources are tailored for law school and preparation for exams such as INM (National Institute of Magistracy), the Bar, and SNG, aligned with the published syllabus and materials.",
    studyMemoryLink: "Explore elements to memorize",
    studyExamsLink: "Preparation for legal exams",
    publicSectionBadge: "YOU DON'T NEED TO KNOW THE LAW TO START",
    publicSectionTitlePart1: "From your situation",
    publicSectionTitlePart2: "to comparable cases.",
    publicSectionDesc: "Maybe you lent money and haven't gotten it back. Maybe you have a dispute with neighbors, your employer, housing, or a contract. You don't need to cite statutory articles or use complex legal jargon.",
    example1: "Lent money not repaid",
    example2: "Neighbor encroached on part of your land",
    example3: "Unpaid salary",
    demoFlowAria: "Steps for finding comparable cases",
    step1Title: "Describe what happened",
    step1Desc: "Write your problem in your own everyday words, just like explaining it to a close friend, without technical terms.",
    step1SampleTag: "Sample input:",
    step1SampleText: "“I lent money to a coworker and they refuse to pay it back, even though we have written confirmations.”",
    step2Title: "Identifying similar cases",
    step2Desc: "The platform searches for lawsuits with comparable circumstances across available materials.",
    step2Tag: "Search by circumstances:",
    step2Bullet1: "Loans between individuals",
    step2Bullet2: "Evidence analyzed: bank transfers, messages",
    step3Title: "See what the judges decided",
    step3Desc: "Examine what factors weighed in the analysis, how evidence was evaluated, and the final judgment delivered.",
    step3Tag: "Available details:",
    step3Bullet1: "Facts and admissible evidence",
    step3Bullet2: "Court ruling and reasoning",
    publicSearchBtn: "Find similar situations",
    publicNote: "Illustrative presentation. Every situation has unique facts. A similar case does not guarantee the same outcome and is not a substitute for legal advice from an attorney.",
    platformSectionBadge: "FOR LEGAL PRACTITIONERS",
    platformSectionTitlePart1: "Legislation and case law",
    platformSectionTitlePart2: "for your research.",
    platformSectionDesc: "Explore legislation, jurisprudence, and relevant files in a workspace built for high precision. Identify primary sources, compare reasoning in judicial motives, and substantiate every conclusion.",
    cardResearchBadge: "RESEARCH",
    cardResearchTitle: "Legislation and jurisprudence",
    cardResearchDesc: "Start with keywords or legal concepts. Explore updated <a href=\"/legislatie\">legislation</a> and court judgments, including <a href=\"/iccj\">High Court (ICCJ) case law</a> and <a href=\"/cedo\">ECHR jurisprudence</a>.",
    cardAnalysisBadge: "LEGAL ANALYSIS",
    cardAnalysisTitle: "Documents in context",
    cardAnalysisDesc: "In search, use Attach to start from the extracted text of a file. For Word documents, check <a href=\"/analiza-document\">document analysis and statutory references</a>.",
    cardDocBadge: "DOCUMENTATION",
    cardDocTitle: "Sources and tools",
    cardDocDesc: "Complement your research with <a href=\"/instrumente-gratuite\">legal deadline calculators and court fee tools</a>. The system assists in organizing materials; evaluation and conclusions remain yours.",
    platformBtn: "Start legal research",
    platformNote: "AI-assisted results may contain omissions. Always verify primary official sources and the applicable version of the statute before use.",
    filmBadge: "DISCOVER LEGEA APLICATĂ",
    filmTitlePart1: "Discover the technology",
    filmTitlePart2: "behind Legea Aplicată.",
    filmDesc: "An overview of the project, the team, and the vision making legal knowledge more accessible and verifiable.",
    filmPlayBtn: "Watch presentation",
    filmCaptionLabel: "BEHIND THE PLATFORM",
    filmCaptionTitle: "Legea Aplicată Presentation",
    videoAria: "Legea Aplicată video presentation",
    methodBadge: "SOURCES, METHOD AND TRUST",
    methodTitlePart1: "Information you can",
    methodTitlePart2: "independently verify.",
    methodDesc1: "Legal materials must be examined in their full context. Similarities between two cases do not guarantee the same outcome, and rules must be checked in their currently applicable version.",
    methodDesc2: "Consult our <a href=\"/surse-date\">legal data sources</a> and details on <a href=\"/securitate\">security and data protection</a>.",
    methodStep1Title: "Start from your question",
    methodStep1Desc: "Describe the issue in your own words or formulate the legal question you are investigating.",
    methodStep2Title: "Compare in context",
    methodStep2Desc: "Read statutory texts and full judicial opinions. Evaluate similarities and distinctions between cases.",
    methodStep3Title: "Verify before using",
    methodStep3Desc: "Check the date, source, and applicable statutory version. For personalized guidance tailored to your case, consult an attorney.",
    faqBadge: "BEFORE YOU BEGIN",
    faqTitlePart1: "Frequently asked questions.",
    faqTitlePart2: "Clear answers.",
    faq1Q: "How do I choose where to start?",
    faq1A: "If you work in the legal field, begin with <a href=\"/cautare\">legal research</a>. If you want to understand a personal issue, <a href=\"/cazuri-asemanatoare\">find similar cases</a> by describing what happened. If you are a student or exam candidate, start with <a href=\"/audio-legislatie\">Audio Legislation</a> and <a href=\"/elemente-de-memorat\">Elements to Memorize</a>.",
    faq2Q: "Do I need to know legal terminology?",
    faq2A: "No. For similar cases, you can write in plain everyday language. Explain what happened, when, and what you need clarified; you do not need statute references to get started.",
    faq3Q: "Does a similar case guarantee the same outcome?",
    faq3A: "No. Circumstances, evidence, and applicable rules vary from one case to another. Compare differences, verify sources, and discuss your situation with a qualified attorney. The platform provides research assistance and does not replace professional legal counsel.",
    faq4Q: "How does Audio Legislation help in exam preparation?",
    faq4A: "The <a href=\"/audio-legislatie\">Audio Legislation</a> module provides synchronized text and audio for statutory codes and laws. You can listen on the go or at home while following the text to master exact statutory provisions.",
    faq5Q: "What does the Elements to Memorize section cover?",
    faq5A: "In <a href=\"/elemente-de-memorat\">Elements to Memorize</a> you will find structured classifications, conditions, exceptions, and key legal rules across essential subjects: civil law, civil procedure, criminal law, and criminal procedure, ideal for law school, INM, Bar, and clerk exams.",
    faq6Q: "Can I start my research from an uploaded document?",
    faq6A: "Yes. In search, the Attach option extracts text from a document or image to search directly based on relevant passages.",
    faq7Q: "How is my data handled and protected?",
    faq7A: "Please review our <a href=\"/privacy-policy\">privacy policy</a> before using documents or personal data on the platform. We strictly adhere to privacy and data security standards.",
    finalCtaBadge: "CHOOSE YOUR STARTING POINT",
    helpToday: "How can we help you",
    today: "today?",
    dockLegalResearch: "Legal research",
    dockSimilarCases: "Similar cases",
    guide: "Features guide",
    guideLink: "All features guide",
    dockGuide: "Guide",
    footerOperator: "Platform operated by VERDICT LINE S.R.L. · <a href=\"/despre-noi\">Team and Operator</a> · <a href=\"/ghid\">Features Guide & Matrix</a> · <a href=\"/contact\">Contact</a>"
  },
  fr: {
    skipToContent: "Passer au contenu",
    searchAria: "LegeaAplicată — Recherche juridique",
    forProfessionals: "Pour professionnels",
    forYou: "Pour vous",
    eyebrow: "LEGEA APLICATĂ · CLARTÉ JURIDIQUE ET RESSOURCES D'ÉTUDE",
    quickStartHint: "Explorez une affaire, un texte de loi ou une notion juridique…",
    quickStartCta: "Essayez gratuitement",
    quickStartAriaLabel: "Explorez une affaire, un texte de loi ou une notion juridique… — Essayez gratuitement",
    heroTitlePart1: "Recherche juridique en ligne.",
    heroTitlePart2: "Informations, jurisprudence et ressources d'étude.",
    heroIntro: "LegeaAplicată réunit des outils pour la recherche juridique, la recherche de cas similaires et la préparation aux examens de droit.",
    howToStart: "Comment souhaitez-vous commencer ?",
    choice1Badge: "POUR PROFESSIONNELS",
    choice1Title: "Recherche et documentation juridique",
    choice1Desc: "Recherchez la législation, les décisions de justice et les motivations. Outils d'analyse et de vérification des sources.",
    choice1Link: "Commencer la recherche juridique",
    choice2Badge: "POUR VOTRE SITUATION",
    choice2Title: "Cas similaires dans vos propres mots",
    choice2Desc: "Décrivez votre problème avec vos propres mots et découvrez ce que les tribunaux ont décidé dans des situations comparables, sans jargon juridique complexe.",
    choice2Link: "Trouver des cas similaires",
    studyBadge: "POUR LES ÉTUDES",
    studyTitle: "Étudiant en droit ou candidat à un examen juridique ?",
    audioLegislation: "Législation Audio",
    elementsToMemorize: "Éléments à mémoriser",
    examPrep: "Préparation aux examens",
    audioQuizzes: "QCM Audio",
    legalCalculators: "Calculateurs juridiques",
    previewAria: "Exemple illustratif de recherche professionnelle",
    previewBadge: "EXEMPLE DE RECHERCHE",
    previewLabel: "DE LA QUESTION AUX SOURCES RÉELLES",
    previewQueryPart1: "Une question claire.",
    previewQueryPart2: "Sources juridiques vérifiées.",
    previewLegislationTitle: "Législation",
    previewLegislationDesc: "Cadre normatif en vigueur",
    previewJurisprudenceTitle: "Jurisprudence",
    previewJurisprudenceDesc: "Décisions et arguments à comparer",
    previewBottom: "Consultez la source intégrale. Vérifiez l'applicabilité.",
    previewCaption: "FLUX ILLUSTRATIF · VOUS GARDEZ LE CONTRÔLE DE L'ANALYSE",
    studySectionBadge: "FACULTÉ DE DROIT ET ADMISSION AUX PROFESSIONS JURIDIQUES",
    studySectionTitlePart1: "Apprenez, révisez,",
    studySectionTitlePart2: "maîtrisez les notions clés.",
    studySectionDesc: "Préparez vos examens juridiques avec la législation audio et des outils de mémorisation. Écoutez, suivez le texte et révisez les classifications, conditions et exceptions clés.",
    studyAudioBadge: "TEXTE ET AUDIO SYNCHRONISÉS",
    studyAudioTitle: "Législation Audio : texte et audio pour l'étude",
    studyAudioDesc: "Écoutez les codes et lois tout en suivant le texte pour approfondir les passages clés. Mettez à profit votre temps à domicile ou en déplacement pour réviser la législation.",
    studyAudioLink: "Écouter la législation",
    audioStudyImageAria: "Ouvrir le module Législation Audio",
    studyMemoryBadge: "RÉVISION STRUCTURÉE",
    studyMemoryTitle: "Éléments à mémoriser pour les examens juridiques",
    studyMemoryDesc: "Ancrez les classifications, conditions, exceptions et règles juridiques grâce à une révision structurée. Révisez les concepts clés et vérifiez vos acquis selon les supports disponibles.",
    studySubjectCivil: "Droit civil",
    studySubjectCivilDesc: "Classifications, obligations, contrats et successions",
    studySubjectCivilProc: "Procédure civile",
    studySubjectCivilProcDesc: "Compétence, actes de procédure, délais et voies de recours",
    studySubjectPenal: "Droit pénal",
    studySubjectPenalDesc: "Partie générale, causes de justification, peines et infractions",
    studySubjectPenalProc: "Procédure pénale",
    studySubjectPenalProcDesc: "Poursuites pénales, mesures préventives et jugement",
    studyMemoryNote: "Ressources adaptées aux études de droit et aux concours tels que l'INM, le Barreau et la SNG, conformément aux programmes officiels.",
    studyMemoryLink: "Explorer les éléments à mémoriser",
    studyExamsLink: "Préparation aux examens juridiques",
    publicSectionBadge: "PAS BESOIN DE CONNAÎTRE LE DROIT POUR COMMENCER",
    publicSectionTitlePart1: "De votre situation",
    publicSectionTitlePart2: "à des cas comparables.",
    publicSectionDesc: "Vous avez prêté de l'argent non remboursé ? Un litige de voisinage, de travail, de logement ou de contrat ? Vous n'avez pas besoin de connaître les articles de loi ni d'employer du jargon juridique.",
    example1: "Prêt d'argent non remboursé",
    example2: "Le voisin a empiété sur votre terrain",
    example3: "Salaire impayé",
    demoFlowAria: "Étapes de recherche de cas comparables",
    step1Title: "Décrivez ce qui s'est passé",
    step1Desc: "Expliquez le problème avec vos propres mots, simplement, comme à un proche, sans termes techniques.",
    step1SampleTag: "Exemple saisi :",
    step1SampleText: "« J'ai prêté de l'argent à un collègue qui refuse de me rembourser, bien que nous ayons des confirmations écrites. »",
    step2Title: "Identification de cas similaires",
    step2Desc: "La plateforme recherche des affaires aux circonstances comparables parmi les dossiers disponibles.",
    step2Tag: "Recherche par circonstances :",
    step2Bullet1: "Prêts entre particuliers",
    step2Bullet2: "Preuves analysées : virements, messages",
    step3Title: "Voyez ce que les juges ont tranché",
    step3Desc: "Consultez les éléments déterminants, l'appréciation des preuves et le jugement rendu.",
    step3Tag: "Informations disponibles :",
    step3Bullet1: "Faits et preuves admises",
    step3Bullet2: "Solution et motivations du tribunal",
    publicSearchBtn: "Chercher des situations similaires",
    publicNote: "Présentation illustrative. Chaque dossier a ses particularités. Un cas similaire ne garantit pas la même issue et ne remplace pas l'analyse d'un avocat.",
    platformSectionBadge: "POUR LES PROFESSIONNELS DU DROIT",
    platformSectionTitlePart1: "Législation et jurisprudence",
    platformSectionTitlePart2: "pour vos recherches.",
    platformSectionDesc: "Explorez les textes, la jurisprudence et les documents dans un espace conçu pour la précision. Identifiez les sources primaires, comparez les motivations judiciaires et étayez chaque conclusion.",
    cardResearchBadge: "RECHERCHE",
    cardResearchTitle: "Législation et jurisprudence",
    cardResearchDesc: "Partez de mots-clés ou de concepts juridiques. Explorez la <a href=\"/legislatie\">législation</a> à jour et les décisions de justice, y compris la <a href=\"/iccj\">jurisprudence de la Haute Cour (ICCJ)</a> et de la <a href=\"/cedo\">CEDH</a>.",
    cardAnalysisBadge: "ANALYSE JURIDIQUE",
    cardAnalysisTitle: "Documents en contexte",
    cardAnalysisDesc: "Dans la recherche, utilisez Joindre pour partir du texte extrait d'un dossier. Pour les fichiers Word, consultez l'<a href=\"/analiza-document\">analyse de documents et de références légales</a>.",
    cardDocBadge: "DOCUMENTATION",
    cardDocTitle: "Sources et outils",
    cardDocDesc: "Complétez votre documentation avec les <a href=\"/instrumente-gratuite\">outils pour les délais et taxes judiciaires</a>. Le système aide à organiser vos sources ; les conclusions vous appartiennent.",
    platformBtn: "Ouvrir la recherche juridique",
    platformNote: "Les résultats assistés peuvent comporter des omissions. Vérifiez toujours les sources officielles et la version applicable avant utilisation.",
    filmBadge: "DÉCOUVREZ LEGEA APLICATĂ",
    filmTitlePart1: "Découvrez la technologie",
    filmTitlePart2: "derrière Legea Aplicată.",
    filmDesc: "Une présentation du projet, des équipes et des idées qui rendent l'information juridique plus accessible et vérifiable.",
    filmPlayBtn: "Voir la présentation",
    filmCaptionLabel: "LES COULISSES DE LA PLATEFORME",
    filmCaptionTitle: "Présentation Legea Aplicată",
    videoAria: "Présentation vidéo Legea Aplicată",
    methodBadge: "SOURCES, MÉTHODE ET CONFIANCE",
    methodTitlePart1: "Des informations que vous",
    methodTitlePart2: "pouvez vérifier.",
    methodDesc1: "Les documents juridiques doivent être consultés dans leur intégralité. Une similitude entre deux affaires ne garantit pas la même issue, et les règles doivent être vérifiées dans leur version en vigueur.",
    methodDesc2: "Consultez les <a href=\"/surse-date\">sources de données juridiques</a> et les détails sur la <a href=\"/securitate\">sécurité et protection des données</a>.",
    methodStep1Title: "Partez de votre question",
    methodStep1Desc: "Décrivez le problème avec vos mots ou formulez la question juridique que vous étudiez.",
    methodStep2Title: "Comparez en contexte",
    methodStep2Desc: "Lisez les textes de loi et les motivations intégrales. Évaluez les similitudes et différences.",
    methodStep3Title: "Vérifiez avant d'utiliser",
    methodStep3Desc: "Vérifiez la date, la source et la version applicable. Pour un avis adapté à votre situation, consultez un avocat.",
    faqBadge: "AVANT DE COMMENCER",
    faqTitlePart1: "Questions fréquentes.",
    faqTitlePart2: "Réponses claires.",
    faq1Q: "Par où dois-je commencer ?",
    faq1A: "Si vous êtes juriste, commencez par la <a href=\"/cautare\">recherche juridique</a>. Si vous souhaitez éclaircir une situation personnelle, <a href=\"/cazuri-asemanatoare\">trouvez des cas similaires</a> en décrivant votre litige. Si vous préparez des examens, commencez par la <a href=\"/audio-legislatie\">Législation Audio</a> et les <a href=\"/elemente-de-memorat\">Éléments à mémoriser</a>.",
    faq2Q: "Dois-je connaître le jargon juridique ?",
    faq2A: "Non. Pour les cas similaires, écrivez simplement avec vos propres mots. Expliquez ce qui s'est passé, quand, et ce que vous souhaitez éclaircir ; nul besoin d'articles de loi pour débuter.",
    faq3Q: "Un cas similaire garantit-il la même issue ?",
    faq3A: "Non. Les circonstances, les preuves et le droit applicable varient d'un dossier à l'autre. Comparez les différences, vérifiez les sources et consultez un avocat. La plateforme informe et ne remplace pas le conseil d'un professionnel.",
    faq4Q: "Comment la Législation Audio aide-t-elle pour les examens ?",
    faq4A: "Le module <a href=\"/audio-legislatie\">Législation Audio</a> propose des codes et lois synchronisés texte-audio. Écoutez les articles en déplacement ou chez vous en suivant le texte pour maîtriser les termes exacts.",
    faq5Q: "Que contient la section Éléments à mémoriser ?",
    faq5A: "Dans <a href=\"/elemente-de-memorat\">Éléments à mémoriser</a>, vous trouverez des synthèses de classifications, conditions, exceptions et règles fondamentales en civil, procédure civile, pénal et procédure pénale, idéales pour les examens et concours.",
    faq6Q: "Puis-je débuter mes recherches à partir d'un document ?",
    faq6A: "Oui. Dans la recherche, l'option Joindre permet d'extraire le texte d'un document ou d'une image pour chercher directement à partir des passages pertinents.",
    faq7Q: "Comment mes données sont-elles traitées ?",
    faq7A: "Consultez notre <a href=\"/privacy-policy\">politique de confidentialité</a> avant d'utiliser des données ou fichiers. Nous respectons des normes strictes de sécurité et de confidentialité.",
    finalCtaBadge: "CHOISISSEZ VOTRE POINT DE DÉPART",
    helpToday: "Comment pouvons-nous vous aider",
    today: "aujourd'hui ?",
    dockLegalResearch: "Recherche juridique",
    dockSimilarCases: "Cas similaires",
    guide: "Guide des fonctions",
    guideLink: "Guide de toutes les fonctions",
    dockGuide: "Guide",
    footerOperator: "Plateforme opérée par VERDICT LINE S.R.L. · <a href=\"/despre-noi\">Équipe et opérateur</a> · <a href=\"/ghid\">Guide des fonctions & Matrice</a> · <a href=\"/contact\">Contact</a>"
  }
};

export default homeTranslations;
